import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-super-star',
    templateUrl: './super-star.component.html',
    standalone: true,
    imports: [
        CommonModule,
    ],
})
export class SuperStarComponent
{

}
